import React, { Component } from 'react'
import { authContext } from '../../Login/AuthContext';
import VentilationTable from '../Ventilation/VentilationTable';
import { Link } from 'react-router-dom'

export default class BenchmarkTable extends Component {
  static contextType = authContext;

  useEffect = () => {
  }

    removeZone = elem =>{
      var choice = this.context.auth.data.selectedZones;
      //choice.push(zones[i])
      choice.splice(elem.target.value, 1)
      this.context.auth.data.selectedZones = choice;
      this.context.setAuthData(this.context.auth.data);
    }

    showDetails = elem =>{
      var data = this.context.auth.data;
      data.zone = elem.target.dataset.zone;
      this.context.setAuthData(data);
      console.log(data.zone)
      ///Booking/Ventilation
    }

  render(){
    if(!this.context.auth.data.selectedZones)
      return (<div className="container"></div>)
    else {
      return (
     <div className="container" key="BenchmarkTable">
          {this.context.auth.data.selectedZones.map((elem, i) =>
            <div className="container" key={"container_bench_"+i}>
              <div className="alert alert-primary" role="alert" key={"bench_zone_"+i}>
                {i+1} - {elem.name}
                <button onClick={this.removeZone} value={i}>-</button>
                <Link to="/Booking/Ventilation" onClick={() => {
                  var data = this.context.auth.data;
                  data.zone = elem;
                  this.context.setAuthData(data);}}>(details)</Link>
              </div>
              <VentilationTable zone={elem} i={i} full={false}/>
            </div>
          )
          }
      </div>
    )}
  }
}
